import { ResponsiveStoreState } from "@/shared/plugins/responsive/Responsive.interfaces";

const state = {
    currentBreakpoint: "x-small" as string,
    currentWindowWidth: null as unknown as number
};

const mutations = {
    setCurrentBreakpoint: function(state: ResponsiveStoreState, breakpoint: string): void{
        state.currentBreakpoint = breakpoint;
    },
    setCurrentWindowWidth: function(state: ResponsiveStoreState, width: number): void {
        state.currentWindowWidth = width;
    }
};

const getters = {
    getCurrentBreakpoint: (state: ResponsiveStoreState): string => {
        return state.currentBreakpoint;
    },
    getCurrentWindowWidth: (state: ResponsiveStoreState): number | unknown => {
        return state.currentWindowWidth;
    }
};

export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    getters: getters
};